import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";
import { updateSiteMedia } from "@/util/patchMediaHelpers.js";

function patchSiteMutation(module, patch) {
  const data = module.getters.homeData();
  Object.keys(patch).forEach((key) => {
    data[key] = patch[key];
  });
  module.commit("storeHomeData", data);
}

const patchSite = async (module, { patch, opts = {} }) => {
  const api = useApiStore();
  const { dispatch } = module;
  const config = Object.assign(getDefaultOpts(), opts);
  if (config.updateStoreFirst) {
    patchSiteMutation(module, patch);
  }
  await dispatch("httpRequest", {
    func: api.patchSite(updateSiteMedia(patch)),
    config,
  });
  if (!config.updateStoreFirst) {
    patchSiteMutation(module, patch);
  }
};

export { patchSite, patchSiteMutation };
